export default __webpack_public_path__ + "static/5_darken-04ddb20ee4d8bef6e625eada395f2d2e.png";